<div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full">
  <app-dropdown
    class="input md:w-[25%] w-full"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['status']"
    [options]="statusFilterList"
    [enableMultiple]="true"
    controlName="status"
    label="Group Status"
    placeholder="Select all that apply"
    type="small"
    [enableClearSelection]="true"
  />
  <app-dropdown
    class="input md:w-[25%] w-full"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['type']"
    [options]="groupTypeFilterList"
    [enableMultiple]="true"
    controlName="type"
    label="Type"
    placeholder="Select all that apply"
    type="small"
    [enableClearSelection]="true"
  />

  <div class="vertical hidden md:block"></div>

  <app-text-input
    class="input w-full md:w-[25%] search-input"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['searchText']"
    (handleSuffixClick)="apply()"
    suffixIcon="search"
    controlName="searchText"
    label="Search"
    placeholder="Search Group"
    type="small"
    [minLength]="1"
  ></app-text-input>

  <div class="vertical hidden md:block"></div>

  <app-primary-button
    type="small"
    class="btn lg:w-[10%] md:w-[15%] w-full"
    (handleClick)="apply()"
    [isDisabled]="!form.dirty"
  >
    Apply
  </app-primary-button>

</div>
